import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { extractAttributesValues } from '../helpers';
import SelectPatientButton from './SelectPatientButton';


const PatientTableRow = ({ customer, isCustomer3, handleCloseModal }) => {
  const {
    firstname,
    lastname,
    email,
    custom_attributes
  } = customer;

  const fullName = `${firstname} ${lastname}`;
  const {phone_number, practice_name} = extractAttributesValues(custom_attributes, ['phone_number', 'practice_name']);

  return (
    <TableRow>
      <TableCell>{fullName}</TableCell>
      <TableCell>{email}</TableCell>
      {isCustomer3 &&
        <TableCell>{practice_name}</TableCell>
      }
      <TableCell>{phone_number}</TableCell>
      <TableCell align="right" className="pr-0">
        <SelectPatientButton customer={customer} handleCloseModal={handleCloseModal} />
      </TableCell>
    </TableRow>
  );
};

export default PatientTableRow;
